var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24,
    filter: "url(#filter0_b_2564_8015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79 154C120.421 154 154 120.421 154 79C154 37.5786 120.421 4 79 4C37.5786 4 4 37.5786 4 79C4 120.421 37.5786 154 79 154Z",
    fill: "url(#paint0_linear_2564_8015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 156C121.526 156 156 121.526 156 79C156 36.4741 121.526 2 79 2C36.4741 2 2 36.4741 2 79C2 121.526 36.4741 156 79 156Z",
    stroke: "#FF85F3",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 156C121.526 156 156 121.526 156 79C156 36.4741 121.526 2 79 2C36.4741 2 2 36.4741 2 79C2 121.526 36.4741 156 79 156Z",
    stroke: "#F300DB",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2564_8015",
    x: -116,
    y: -116,
    width: 390,
    height: 390,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 58
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2564_8015"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2564_8015",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2564_8015",
    x1: 4,
    y1: 79,
    x2: 154,
    y2: 79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB307"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSb);
export default __webpack_public_path__ + "static/media/sb.721a5eb6dc48800bd58a1a4b3b94b4ea.svg";
export { ForwardRef as ReactComponent };